<div class="flex flex-col gap-6">
  <span class="text-xl font-bold">Datos funcionales</span>

  <div class="flex flex-col gap-6">
    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('systemFinality')"
        (change)="reviewFields.toggleField('systemFinality')" />

      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <span class="text-sm text-neutral-dark">Finalidad del proyecto</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('systemFinality')"
            class="-mt-2"
            [description]="previousReviewText('systemFinality')"
            tipeIcon="info"></app-tooltip>
        </div>
        <span class="text-[16px] font-normal">
          {{ project?.systemFinality || '-' }}
        </span>
      </div>
    </div>
    <div class="grid grid-cols-2 gap-6">
      <div class="flex gap-3 items-start col-span-2">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('selectedProcedure')"
          (change)="reviewFields.toggleField('selectedProcedure')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-sm text-neutral-dark">Procedimientos administrativos</span>
            <app-tooltip
              *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('selectedProcedure')"
              class="-mt-2"
              [description]="previousReviewText('selectedProcedure')"
              tipeIcon="info"></app-tooltip>
          </div>

          <div class="flex flex-wrap gap-2">
            @for (item of project?.selectedProcedure || []; track item) {
              <app-pill
                [value]="item.code + ' - ' + item.name"
                [classe]="'c-pill--primary'" />
            }
          </div>
        </div>
      </div>
      <div class="flex gap-3 items-start col-span-2">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('systemOrApp')"
          (change)="reviewFields.toggleField('systemOrApp')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-sm text-neutral-dark">Aplicaciones o sistemas relacionados</span>
            <app-tooltip
              *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('systemOrApp')"
              class="-mt-2"
              [description]="previousReviewText('systemOrApp')"
              tipeIcon="info"></app-tooltip>
          </div>

          <div class="flex flex-wrap gap-2">
            @for (item of project?.systemOrApp || []; track item) {
              <app-pill
                [value]="item || '-'"
                [classe]="'c-pill--primary'" />
            }
          </div>
        </div>
      </div>
    </div>
    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('administrativeProcess')"
        (change)="reviewFields.toggleField('administrativeProcess')" />

      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <span class="text-sm text-neutral-dark">Trámite administrativo</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('administrativeProcess')"
            class="-mt-2"
            [description]="previousReviewText('administrativeProcess')"
            tipeIcon="info"></app-tooltip>
        </div>

        <span class="text-[16px] font-normal">
          {{ project?.administrativeProcess || '-' }}
        </span>
      </div>
    </div>
  </div>
</div>
